import { Icons } from "../../config/MuiIcons.config";
import { AppTheme } from "../../theme/App.theme";
import { useMediaQuery } from "@mui/material";

const ImagePreview = ({ ImageUrl, TogglePreview }) => {
  let isMobileMid = useMediaQuery('(max-width:500px)');
  // style for image preview container
  const ImagePreviewConatinerStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, .3)",
    zIndex: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  };
  // custom style for image preview
  const ImagepreviewStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, .5)",
    zIndex: 1000,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  };

  const CloseIconStyle = {
    marginLeft: !isMobileMid && "40%",
    width: "40px",
    cursor: "pointer",
    height: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: AppTheme.MUTED_LIGHT,
    borderRadius: "50%",
  };

  // Adding aspect ratio for the image container
  const ImageContainerStyle = {
    width: !isMobileMid ? "350px" : "200px",
    height: !isMobileMid ? "350px" : "200px",  // maintaining a 1:1 ratio
    overflow: "hidden",
  };

  const ImageStyle = {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  };

  return (
    <div style={ImagePreviewConatinerStyle}>
      <div style={ImagepreviewStyle} onClick={TogglePreview}>
        <div className="my-3" style={CloseIconStyle}>
          <Icons.Close />
        </div>
        <div style={ImageContainerStyle}>
          <img src={ImageUrl} style={ImageStyle} alt="Preview" />
        </div>
      </div>
    </div>
  );
};

export default ImagePreview;
